// extracted by mini-css-extract-plugin
export var attachment = "_mw-a";
export var emailContainer = "_mw-4";
export var emailContentPaddedContainer = "_mw-b";
export var emailHeader = "_mw-6";
export var emailIframe = "_mw-3";
export var emailInfoIcon = "_mw-9";
export var emailShortenedSummary = "_mw-e";
export var infoDropdown = "_mw-0";
export var infoRowBoundedContent = "_mw-d";
export var internal = "_mw-5";
export var merchant = "_mw-8";
export var messageInputContainer = "_mw-h";
export var normal = "_mw-7";
export var replyCard = "_mw-f";
export var subtleButton = "_mw-1";
export var subtleButtonIconContainer = "_mw-2";
export var toggleViewRepliesButton = "_mw-c";
export var wrappingText = "_mw-g";